"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryRedelegationTxResponse = exports.QueryRedelegationTxRequest = exports.QueryRedelegationsResponse = exports.QueryRedelegationsRequest = exports.QueryExchangeRateResponse = exports.QueryExchangeRateRequest = exports.QueryDepositAccountBalanceResponse = exports.QueryDepositAccountBalanceRequest = exports.QueryValidatorUnbondingResponse = exports.QueryValidatorUnbondingRequest = exports.QueryHostChainUserUnbondingsResponse = exports.QueryHostChainUserUnbondingsRequest = exports.QueryUserUnbondingsResponse = exports.QueryUserUnbondingsRequest = exports.QueryUnbondingResponse = exports.QueryUnbondingRequest = exports.QueryUnbondingsResponse = exports.QueryUnbondingsRequest = exports.QueryLSMDepositsResponse = exports.QueryLSMDepositsRequest = exports.QueryDepositsResponse = exports.QueryDepositsRequest = exports.QueryHostChainsResponse = exports.QueryHostChainsRequest = exports.QueryHostChainResponse = exports.QueryHostChainRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const params_1 = require("./params");
const liquidstakeibc_1 = require("./liquidstakeibc");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.liquidstakeibc.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryParamsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: params_1.Params.fromPartial({}),
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryParamsResponse();
        if ((0, helpers_1.isSet)(object.params))
            obj.params = params_1.Params.fromJSON(object.params);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        return message;
    },
};
function createBaseQueryHostChainRequest() {
    return {
        chainId: "",
    };
}
exports.QueryHostChainRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryHostChainResponse() {
    return {
        hostChain: liquidstakeibc_1.HostChain.fromPartial({}),
    };
}
exports.QueryHostChainResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.hostChain !== undefined) {
            liquidstakeibc_1.HostChain.encode(message.hostChain, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostChain = liquidstakeibc_1.HostChain.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainResponse();
        if ((0, helpers_1.isSet)(object.hostChain))
            obj.hostChain = liquidstakeibc_1.HostChain.fromJSON(object.hostChain);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.hostChain !== undefined &&
            (obj.hostChain = message.hostChain ? liquidstakeibc_1.HostChain.toJSON(message.hostChain) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainResponse();
        if (object.hostChain !== undefined && object.hostChain !== null) {
            message.hostChain = liquidstakeibc_1.HostChain.fromPartial(object.hostChain);
        }
        return message;
    },
};
function createBaseQueryHostChainsRequest() {
    return {};
}
exports.QueryHostChainsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryHostChainsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryHostChainsRequest();
        return message;
    },
};
function createBaseQueryHostChainsResponse() {
    return {
        hostChains: [],
    };
}
exports.QueryHostChainsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.hostChains) {
            liquidstakeibc_1.HostChain.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostChains.push(liquidstakeibc_1.HostChain.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainsResponse();
        if (Array.isArray(object?.hostChains))
            obj.hostChains = object.hostChains.map((e) => liquidstakeibc_1.HostChain.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.hostChains) {
            obj.hostChains = message.hostChains.map((e) => (e ? liquidstakeibc_1.HostChain.toJSON(e) : undefined));
        }
        else {
            obj.hostChains = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainsResponse();
        message.hostChains = object.hostChains?.map((e) => liquidstakeibc_1.HostChain.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryDepositsRequest() {
    return {
        chainId: "",
    };
}
exports.QueryDepositsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDepositsRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryDepositsResponse() {
    return {
        deposits: [],
    };
}
exports.QueryDepositsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.deposits) {
            liquidstakeibc_1.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposits.push(liquidstakeibc_1.Deposit.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDepositsResponse();
        if (Array.isArray(object?.deposits))
            obj.deposits = object.deposits.map((e) => liquidstakeibc_1.Deposit.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.deposits) {
            obj.deposits = message.deposits.map((e) => (e ? liquidstakeibc_1.Deposit.toJSON(e) : undefined));
        }
        else {
            obj.deposits = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e) => liquidstakeibc_1.Deposit.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryLSMDepositsRequest() {
    return {
        chainId: "",
    };
}
exports.QueryLSMDepositsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLSMDepositsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryLSMDepositsRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLSMDepositsRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryLSMDepositsResponse() {
    return {
        deposits: [],
    };
}
exports.QueryLSMDepositsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.deposits) {
            liquidstakeibc_1.LSMDeposit.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLSMDepositsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposits.push(liquidstakeibc_1.LSMDeposit.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryLSMDepositsResponse();
        if (Array.isArray(object?.deposits))
            obj.deposits = object.deposits.map((e) => liquidstakeibc_1.LSMDeposit.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.deposits) {
            obj.deposits = message.deposits.map((e) => (e ? liquidstakeibc_1.LSMDeposit.toJSON(e) : undefined));
        }
        else {
            obj.deposits = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLSMDepositsResponse();
        message.deposits = object.deposits?.map((e) => liquidstakeibc_1.LSMDeposit.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryUnbondingsRequest() {
    return {
        chainId: "",
    };
}
exports.QueryUnbondingsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingsRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingsRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryUnbondingsResponse() {
    return {
        unbondings: [],
    };
}
exports.QueryUnbondingsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.unbondings) {
            liquidstakeibc_1.Unbonding.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondings.push(liquidstakeibc_1.Unbonding.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingsResponse();
        if (Array.isArray(object?.unbondings))
            obj.unbondings = object.unbondings.map((e) => liquidstakeibc_1.Unbonding.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.unbondings) {
            obj.unbondings = message.unbondings.map((e) => (e ? liquidstakeibc_1.Unbonding.toJSON(e) : undefined));
        }
        else {
            obj.unbondings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingsResponse();
        message.unbondings = object.unbondings?.map((e) => liquidstakeibc_1.Unbonding.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryUnbondingRequest() {
    return {
        chainId: "",
        epoch: BigInt(0),
    };
}
exports.QueryUnbondingRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.epoch !== BigInt(0)) {
            writer.uint32(16).int64(message.epoch);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.epoch = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.epoch))
            obj.epoch = BigInt(object.epoch.toString());
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.epoch !== undefined && (obj.epoch = (message.epoch || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingRequest();
        message.chainId = object.chainId ?? "";
        if (object.epoch !== undefined && object.epoch !== null) {
            message.epoch = BigInt(object.epoch.toString());
        }
        return message;
    },
};
function createBaseQueryUnbondingResponse() {
    return {
        unbonding: liquidstakeibc_1.Unbonding.fromPartial({}),
    };
}
exports.QueryUnbondingResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.unbonding !== undefined) {
            liquidstakeibc_1.Unbonding.encode(message.unbonding, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbonding = liquidstakeibc_1.Unbonding.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingResponse();
        if ((0, helpers_1.isSet)(object.unbonding))
            obj.unbonding = liquidstakeibc_1.Unbonding.fromJSON(object.unbonding);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.unbonding !== undefined &&
            (obj.unbonding = message.unbonding ? liquidstakeibc_1.Unbonding.toJSON(message.unbonding) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingResponse();
        if (object.unbonding !== undefined && object.unbonding !== null) {
            message.unbonding = liquidstakeibc_1.Unbonding.fromPartial(object.unbonding);
        }
        return message;
    },
};
function createBaseQueryUserUnbondingsRequest() {
    return {
        address: "",
    };
}
exports.QueryUserUnbondingsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUserUnbondingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUserUnbondingsRequest();
        if ((0, helpers_1.isSet)(object.address))
            obj.address = String(object.address);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUserUnbondingsRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryUserUnbondingsResponse() {
    return {
        userUnbondings: [],
    };
}
exports.QueryUserUnbondingsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.userUnbondings) {
            liquidstakeibc_1.UserUnbonding.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUserUnbondingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userUnbondings.push(liquidstakeibc_1.UserUnbonding.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUserUnbondingsResponse();
        if (Array.isArray(object?.userUnbondings))
            obj.userUnbondings = object.userUnbondings.map((e) => liquidstakeibc_1.UserUnbonding.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.userUnbondings) {
            obj.userUnbondings = message.userUnbondings.map((e) => (e ? liquidstakeibc_1.UserUnbonding.toJSON(e) : undefined));
        }
        else {
            obj.userUnbondings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUserUnbondingsResponse();
        message.userUnbondings = object.userUnbondings?.map((e) => liquidstakeibc_1.UserUnbonding.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryHostChainUserUnbondingsRequest() {
    return {
        chainId: "",
        pagination: pagination_1.PageRequest.fromPartial({}),
    };
}
exports.QueryHostChainUserUnbondingsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainUserUnbondingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainUserUnbondingsRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.pagination))
            obj.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainUserUnbondingsRequest();
        message.chainId = object.chainId ?? "";
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        return message;
    },
};
function createBaseQueryHostChainUserUnbondingsResponse() {
    return {
        userUnbondings: [],
        pagination: pagination_1.PageResponse.fromPartial({}),
    };
}
exports.QueryHostChainUserUnbondingsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.userUnbondings) {
            liquidstakeibc_1.UserUnbonding.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainUserUnbondingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userUnbondings.push(liquidstakeibc_1.UserUnbonding.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainUserUnbondingsResponse();
        if (Array.isArray(object?.userUnbondings))
            obj.userUnbondings = object.userUnbondings.map((e) => liquidstakeibc_1.UserUnbonding.fromJSON(e));
        if ((0, helpers_1.isSet)(object.pagination))
            obj.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.userUnbondings) {
            obj.userUnbondings = message.userUnbondings.map((e) => (e ? liquidstakeibc_1.UserUnbonding.toJSON(e) : undefined));
        }
        else {
            obj.userUnbondings = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainUserUnbondingsResponse();
        message.userUnbondings = object.userUnbondings?.map((e) => liquidstakeibc_1.UserUnbonding.fromPartial(e)) || [];
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        return message;
    },
};
function createBaseQueryValidatorUnbondingRequest() {
    return {
        chainId: "",
    };
}
exports.QueryValidatorUnbondingRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryValidatorUnbondingRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorUnbondingRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryValidatorUnbondingResponse() {
    return {
        validatorUnbondings: [],
    };
}
exports.QueryValidatorUnbondingResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.validatorUnbondings) {
            liquidstakeibc_1.ValidatorUnbonding.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorUnbondings.push(liquidstakeibc_1.ValidatorUnbonding.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryValidatorUnbondingResponse();
        if (Array.isArray(object?.validatorUnbondings))
            obj.validatorUnbondings = object.validatorUnbondings.map((e) => liquidstakeibc_1.ValidatorUnbonding.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.validatorUnbondings) {
            obj.validatorUnbondings = message.validatorUnbondings.map((e) => e ? liquidstakeibc_1.ValidatorUnbonding.toJSON(e) : undefined);
        }
        else {
            obj.validatorUnbondings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorUnbondingResponse();
        message.validatorUnbondings =
            object.validatorUnbondings?.map((e) => liquidstakeibc_1.ValidatorUnbonding.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryDepositAccountBalanceRequest() {
    return {
        chainId: "",
    };
}
exports.QueryDepositAccountBalanceRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositAccountBalanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDepositAccountBalanceRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositAccountBalanceRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryDepositAccountBalanceResponse() {
    return {
        balance: coin_1.Coin.fromPartial({}),
    };
}
exports.QueryDepositAccountBalanceResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositAccountBalanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDepositAccountBalanceResponse();
        if ((0, helpers_1.isSet)(object.balance))
            obj.balance = coin_1.Coin.fromJSON(object.balance);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositAccountBalanceResponse();
        if (object.balance !== undefined && object.balance !== null) {
            message.balance = coin_1.Coin.fromPartial(object.balance);
        }
        return message;
    },
};
function createBaseQueryExchangeRateRequest() {
    return {
        chainId: "",
    };
}
exports.QueryExchangeRateRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryExchangeRateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryExchangeRateRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryExchangeRateRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryExchangeRateResponse() {
    return {
        rate: "",
    };
}
exports.QueryExchangeRateResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.rate !== "") {
            writer.uint32(10).string(message.rate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryExchangeRateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryExchangeRateResponse();
        if ((0, helpers_1.isSet)(object.rate))
            obj.rate = String(object.rate);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryExchangeRateResponse();
        message.rate = object.rate ?? "";
        return message;
    },
};
function createBaseQueryRedelegationsRequest() {
    return {
        chainId: "",
    };
}
exports.QueryRedelegationsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryRedelegationsRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationsRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryRedelegationsResponse() {
    return {
        redelegations: liquidstakeibc_1.Redelegations.fromPartial({}),
    };
}
exports.QueryRedelegationsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.redelegations !== undefined) {
            liquidstakeibc_1.Redelegations.encode(message.redelegations, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegations = liquidstakeibc_1.Redelegations.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryRedelegationsResponse();
        if ((0, helpers_1.isSet)(object.redelegations))
            obj.redelegations = liquidstakeibc_1.Redelegations.fromJSON(object.redelegations);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.redelegations !== undefined &&
            (obj.redelegations = message.redelegations ? liquidstakeibc_1.Redelegations.toJSON(message.redelegations) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationsResponse();
        if (object.redelegations !== undefined && object.redelegations !== null) {
            message.redelegations = liquidstakeibc_1.Redelegations.fromPartial(object.redelegations);
        }
        return message;
    },
};
function createBaseQueryRedelegationTxRequest() {
    return {
        chainId: "",
    };
}
exports.QueryRedelegationTxRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryRedelegationTxRequest();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationTxRequest();
        message.chainId = object.chainId ?? "";
        return message;
    },
};
function createBaseQueryRedelegationTxResponse() {
    return {
        redelegationTx: [],
    };
}
exports.QueryRedelegationTxResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.redelegationTx) {
            liquidstakeibc_1.RedelegateTx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegationTx.push(liquidstakeibc_1.RedelegateTx.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryRedelegationTxResponse();
        if (Array.isArray(object?.redelegationTx))
            obj.redelegationTx = object.redelegationTx.map((e) => liquidstakeibc_1.RedelegateTx.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.redelegationTx) {
            obj.redelegationTx = message.redelegationTx.map((e) => (e ? liquidstakeibc_1.RedelegateTx.toJSON(e) : undefined));
        }
        else {
            obj.redelegationTx = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationTxResponse();
        message.redelegationTx = object.redelegationTx?.map((e) => liquidstakeibc_1.RedelegateTx.fromPartial(e)) || [];
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.HostChain = this.HostChain.bind(this);
        this.HostChains = this.HostChains.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.LSMDeposits = this.LSMDeposits.bind(this);
        this.Unbondings = this.Unbondings.bind(this);
        this.Unbonding = this.Unbonding.bind(this);
        this.UserUnbondings = this.UserUnbondings.bind(this);
        this.HostChainUserUnbondings = this.HostChainUserUnbondings.bind(this);
        this.ValidatorUnbondings = this.ValidatorUnbondings.bind(this);
        this.DepositAccountBalance = this.DepositAccountBalance.bind(this);
        this.ExchangeRate = this.ExchangeRate.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.RedelegationTx = this.RedelegationTx.bind(this);
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostChain(request) {
        const data = exports.QueryHostChainRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "HostChain", data);
        return promise.then((data) => exports.QueryHostChainResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostChains(request = {}) {
        const data = exports.QueryHostChainsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "HostChains", data);
        return promise.then((data) => exports.QueryHostChainsResponse.decode(new binary_1.BinaryReader(data)));
    }
    Deposits(request) {
        const data = exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "Deposits", data);
        return promise.then((data) => exports.QueryDepositsResponse.decode(new binary_1.BinaryReader(data)));
    }
    LSMDeposits(request) {
        const data = exports.QueryLSMDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "LSMDeposits", data);
        return promise.then((data) => exports.QueryLSMDepositsResponse.decode(new binary_1.BinaryReader(data)));
    }
    Unbondings(request) {
        const data = exports.QueryUnbondingsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "Unbondings", data);
        return promise.then((data) => exports.QueryUnbondingsResponse.decode(new binary_1.BinaryReader(data)));
    }
    Unbonding(request) {
        const data = exports.QueryUnbondingRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "Unbonding", data);
        return promise.then((data) => exports.QueryUnbondingResponse.decode(new binary_1.BinaryReader(data)));
    }
    UserUnbondings(request) {
        const data = exports.QueryUserUnbondingsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "UserUnbondings", data);
        return promise.then((data) => exports.QueryUserUnbondingsResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostChainUserUnbondings(request) {
        const data = exports.QueryHostChainUserUnbondingsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "HostChainUserUnbondings", data);
        return promise.then((data) => exports.QueryHostChainUserUnbondingsResponse.decode(new binary_1.BinaryReader(data)));
    }
    ValidatorUnbondings(request) {
        const data = exports.QueryValidatorUnbondingRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "ValidatorUnbondings", data);
        return promise.then((data) => exports.QueryValidatorUnbondingResponse.decode(new binary_1.BinaryReader(data)));
    }
    DepositAccountBalance(request) {
        const data = exports.QueryDepositAccountBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "DepositAccountBalance", data);
        return promise.then((data) => exports.QueryDepositAccountBalanceResponse.decode(new binary_1.BinaryReader(data)));
    }
    ExchangeRate(request) {
        const data = exports.QueryExchangeRateRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "ExchangeRate", data);
        return promise.then((data) => exports.QueryExchangeRateResponse.decode(new binary_1.BinaryReader(data)));
    }
    Redelegations(request) {
        const data = exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "Redelegations", data);
        return promise.then((data) => exports.QueryRedelegationsResponse.decode(new binary_1.BinaryReader(data)));
    }
    RedelegationTx(request) {
        const data = exports.QueryRedelegationTxRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstakeibc.v1beta1.Query", "RedelegationTx", data);
        return promise.then((data) => exports.QueryRedelegationTxResponse.decode(new binary_1.BinaryReader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map